// src/components/BoekTaxi.js
import React from 'react';
import './BoekTaxi.css'; // Import the CSS file

function BoekTaxi() {
    const handleClick = (event) => {
        event.preventDefault(); // Prevent form submission
        //console.log('Button clicked!'); // Add this line
        alert('Deze functionaliteit is nog niet beschikbaar. U kunt telefonisch uw boeking doorgeven op 020-7370833');
    };
  return (
    <div className="booking-module">
      <form className="booking-container">
        <div className="header">
          <h2 className="booking-title">Boek eenvoudig je taxirit</h2>
        </div>
        <div className="body">
          <table>
            <tbody>
              <tr>
                <td>
                  <strong>Waar wil je heen?</strong>
                </td>
                <td>
                  <div className="travel-form">
                    <div className="route">
                      <div className="route-row startpoint">
                        <div className="input-group">
                          <div className="left-text">van</div>
                          <input
                            type="text"
                            placeholder="straatnaam met huisnummer"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="route-row endpoint">
                        <div className="input-group">
                          <div className="left-text">naar</div>
                          <input
                            type="text"
                            placeholder="straatnaam met huisnummer"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="fs-small mb-2">Reis je met bagage?</label>
                </td>
                <td>
                  <div className="radio-group">
                    <label className="radio-button">
                      <input type="radio" name="luggage" value="yes" />
                      Ja
                    </label>
                    <label className="radio-button">
                      <input type="radio" name="luggage" value="no" />
                      Nee, ik heb geen bagage
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="date" className="fs-small">
                    Ophaalmoment taxi
                  </label>
                </td>
                <td>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="date"
                      placeholder="Selecteer datum en tijd"
                      className="form-control"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="fs-small">
                    <input type="checkbox" /> Retour
                  </label>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <label htmlFor="travelers" className="fs-small">
                    Aantal reizigers
                  </label>
                </td>
                <td>
                  <input
                    type="number"
                    id="travelers"
                    min="1"
                    placeholder="1"
                    className="form-control"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="footer">
                  <button className="button" onClick={handleClick}>Bereken mijn ritprijs  </button>
        </div>
      </form>
    </div>
  );
}

export default BoekTaxi;
